export { BookingNotificationContent } from './BookingNotificationContent';
export type {
  BookingNotificationContentProps,
  BookingNotificationLabels,
} from './BookingNotificationContent.types';
